import { Button, Divider, Text } from '@wework/dieter-ui'
import React, { FunctionComponent, useEffect, useState } from 'react'
import './styles.css'
import IMTheme from '../../style/IMTheme'
import attentionIcon from '../../assets/icons/attentionIcon.png'
import Row from '../Common/Row'
import CreateProduct from '../Drawer/CreateProduct'
import Linkeable from '../Drawer/LinkRoom/Linkeable'
import { useSidebar } from '../../hoc/withSidebar'
import _ from 'lodash'
import { Grid, Loader } from 'semantic-ui-react'
import changeCase from 'change-case'

interface NotLinkedProps {
  space: any
  floorMap: any
  snackBars: any
  currentBuilding: any
  border?: boolean
  containerStyle?: React.CSSProperties
}

const NotLinked: FunctionComponent<NotLinkedProps> = ({
  space,
  floorMap,
  snackBars,
  currentBuilding,
  border = false,
  containerStyle = {},
}) => {
  const { openSideBar, closeSideBar } = useSidebar()
  const [suggestedInventory, setSuggestedInventory] = useState<any>()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const inventoryExt = floorMap.getExtension('inventoryData')
    const currentFloor = floorMap.getCurrentFloor()
    const subType = space.subType?.toUpperCase()
    const programType = space.programType?.toUpperCase()

    let type: string
    let roomNumber = space?.number
    if (space?.number.includes('BPO')) {
      roomNumber = space?.number.replace('BPO-', '')
    }
    if (subType === 'OFFICE') {
      type = 'PRIVATE_OFFICE'
    } else if (programType === 'MEET') {
      type = 'CONFERENCE_ROOM'
    } else {
      type = changeCase.title(subType)
    }
    setIsLoading(true)
    inventoryExt
      .getSuggetstedInventorys(currentFloor.uuid, type, roomNumber)
      .then(res => {
        setSuggestedInventory(res.data && res.data[0])
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [floorMap, space])

  if (!space) {
    return null
  }

  const handleLinkProduct = () => openSideBar('Linkeage')

  const handleCreateProduct = async productType => {
    const inventoryExt = floorMap.getExtension('inventoryData')
    try {
      const response = await inventoryExt.createProduct(
        floorMap.getCurrentBuilding().uuid,
        floorMap.getCurrentFloor().uuid,
        space,
        productType
      )
      const { data, meta } = response
      if (!meta.success) {
        throw new Error(meta.message)
      }
      snackBars?.addAlert({
        text: `Created a new inventory for ${space.number}.`,
        variant: 'success',
      })
      openSideBar('EditDrawer')
    } catch (error) {
      snackBars?.addAlert({
        text: 'Ops! Something went wrong, please try again.',
        variant: 'error',
      })
    }
  }

  const assignSystemIdToSpaces = () => {
    setIsLoading(true)
    let systemUUID = ''

    if (suggestedInventory) {
      systemUUID = suggestedInventory.attributes.uuid
    }

    return new Promise((resolve, reject) => {
      const floor = floorMap.getCurrentFloor().uuid

      floorMap.extensions.classification
        .assignSystemUUIDToSpacesAndDesks(floor, systemUUID, [space])
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  const refreshReservableAndBuildingIndex = async () => {
    const reservableExtension = floorMap.extensions.reservable
    const inventoryExt = floorMap.getExtension('inventoryData')

    if (!reservableExtension) {
      return
    }

    const currentBuilding = floorMap.getCurrentBuilding()
    const currentFloor = floorMap.getCurrentFloor()
    const buildingUUID = _.get(currentBuilding, 'systemUUID')

    if (!buildingUUID) {
      return
    }

    const fetchBuildingIndex = _.get(
      floorMap,
      'extensions.buildingIndex.fetchBuildingIndex',
      () => {}
    )

    await Promise.all([
      reservableExtension.fetchOccupancies(buildingUUID),
      fetchBuildingIndex(currentBuilding.uuid),
      inventoryExt.getInventory(currentFloor.uuid, true),
    ])

    return
  }

  const handleLinkSuggestInventory = async () => {
    const reservableExtension = floorMap.extensions.reservable

    try {
      await assignSystemIdToSpaces()
    } catch (err) {
      console.error(err)

      snackBars.addAlert({
        text: `Ops! Something went wrong, please try again.`,
        variant: 'failed',
      })
      setIsLoading(false)
      return
    }

    try {
      await refreshReservableAndBuildingIndex()
      // spaces.forEach(space => {
      //   floorMap.updateData(space.uuid)
      // })

      floorMap.extensions.BASE_STYLE_EXTENSION.reload()
      reservableExtension.reloadMapStyles()
    } catch (e) {
      // setShowReloadDialog(true)
    }
    setIsLoading(false)
    closeSideBar()
    snackBars.addAlert({
      text: `Linked successfuly!`,
      variant: 'success',
    })
  }

  let linkSpace
  if (suggestedInventory) {
    linkSpace = {
      uuid: suggestedInventory?.attributes.uuid,
      number: suggestedInventory?.attributes.office_num,
    }
  }

  const isSuggested = !!suggestedInventory
  if (isLoading) {
    return (
      <Grid style={{ padding: 8, height: '100px' }}>
        <Loader active inline="centered" />
      </Grid>
    )
  }
  return (
    <div
      style={{
        position: 'relative',
        padding: 0,
        borderRadius: '.25rem',
        border: border ? '1px solid #E6E6E6' : 0,
        ...containerStyle,
      }}
    >
      <Text style={{ fontSize: IMTheme.fontSizes[2] }}>
        <img
          src={attentionIcon}
          alt="Attention"
          style={{ width: 16, height: 16, marginRight: 2, marginTop: 2 }}
        />
        {
          'Get information about this inventory by linking this space to an inventory.'
        }
      </Text>
      {isSuggested ? (
        <>
          <Divider
            light
            style={{
              marginTop: IMTheme.spacing[5],
              marginBottom: IMTheme.spacing[5],
            }}
          />
          <Text
            style={{
              fontSize: IMTheme.fontSizes[2],
              fontWeight: IMTheme.fontWeights.bold,
            }}
          >
            Suggested inventory
          </Text>
          <Text
            style={{
              fontSize: IMTheme.fontSizes[2],
              marginBottom: IMTheme.spacing[4],
            }}
          >
            We found an inventory that might be a match for this space.
          </Text>
          <Linkeable space={linkSpace} />
          <Row
            style={{
              marginTop: IMTheme.spacing[5],
            }}
          >
            <Button
              basic
              color="blue"
              style={{
                marginRight: IMTheme.spacing[4],
              }}
              onClick={handleLinkSuggestInventory}
            >
              Link this
            </Button>
            <Text
              style={{
                fontSize: IMTheme.fontSizes[2],
                marginRight: IMTheme.spacing[3],
                color: IMTheme.colors.primary,
                cursor: 'pointer',
              }}
              onClick={handleLinkProduct}
            >
              Select different inventory
            </Text>
          </Row>
        </>
      ) : (
        <Row justify="flex-start">
          <Button
            basic
            color="blue"
            style={{
              marginTop: IMTheme.spacing[5],
              marginRight: IMTheme.spacing[3],
              fontSize: IMTheme.fontSizes[2],
            }}
            onClick={handleLinkProduct}
          >
            Link inventory
          </Button>
          {handleCreateProduct && (
            <CreateProduct
              space={space}
              handleLinkProduct={handleLinkProduct}
              handleCreateProduct={handleCreateProduct}
              trigger={
                <Button
                  basic
                  color="blue"
                  style={{
                    marginTop: IMTheme.spacing[5],
                    fontSize: IMTheme.fontSizes[2],
                  }}
                >
                  Create inventory
                </Button>
              }
            />
          )}
        </Row>
      )}
    </div>
  )
}

export default NotLinked
